var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber3Red(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_868_15331)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_15331)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#912018"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_868_15331)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8525,
    cy: 15.0596,
    rx: 24.1463,
    ry: 23.7024,
    fill: "#F97066"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_868_15331)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6317,
    cy: 11.7856,
    rx: 14.7561,
    ry: 14.4048,
    fill: "#FDA29B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_868_15331)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.2504,
    cy: 3.73998,
    rx: 6.2504,
    ry: 3.73998,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 20.1201 37.7185)",
    fill: "#F04438"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 8.76C20.8533 8.76 21.96 8.94667 22.92 9.32C23.9067 9.69333 24.68 10.2267 25.24 10.92C25.8 11.5867 26.08 12.4 26.08 13.36C26.08 14.3733 25.76 15.32 25.12 16.2C24.48 17.08 23.6 17.84 22.48 18.48C21.3867 19.12 20.12 19.6133 18.68 19.96C20.3067 19.9333 21.7867 20.1467 23.12 20.6C24.4533 21.0267 25.52 21.7067 26.32 22.64C27.12 23.5467 27.52 24.6933 27.52 26.08C27.52 27.3067 27.2 28.44 26.56 29.48C25.92 30.4933 25.0533 31.4 23.96 32.2C22.8933 33.0267 21.6533 33.72 20.24 34.28C18.8267 34.8667 17.3467 35.3067 15.8 35.6C14.28 35.8933 12.7733 36.04 11.28 36.04V35.28C12.56 35.2267 13.84 35 15.12 34.6C16.4267 34.2 17.6133 33.6133 18.68 32.84C19.7733 32.0667 20.64 31.12 21.28 30C21.9467 28.8533 22.28 27.5467 22.28 26.08C22.28 24.5067 21.9067 23.2133 21.16 22.2C20.4133 21.1867 19.3867 20.6267 18.08 20.52C17.68 20.68 17.3067 20.8267 16.96 20.96C16.64 21.0933 16.3333 21.16 16.04 21.16C15.8267 21.16 15.6533 21.12 15.52 21.04C15.4133 20.9333 15.36 20.7733 15.36 20.56C15.36 20.2933 15.48 20.0933 15.72 19.96C15.96 19.8267 16.24 19.76 16.56 19.76C16.7733 19.76 16.9867 19.7733 17.2 19.8C17.44 19.8267 17.6933 19.8533 17.96 19.88C19.08 19.08 19.8667 18.2133 20.32 17.28C20.8 16.32 21.04 15.36 21.04 14.4C21.04 13.1733 20.72 12.28 20.08 11.72C19.44 11.1333 18.5867 10.84 17.52 10.84C16.4533 10.84 15.4533 11.12 14.52 11.68C13.6133 12.2133 12.8533 13.0267 12.24 14.12L11.56 13.76C12.0133 12.88 12.5733 12.0667 13.24 11.32C13.9333 10.5467 14.8 9.93333 15.84 9.48C16.88 9 18.1333 8.76 19.6 8.76Z",
    fill: "#7A271A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_868_15331",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.2771,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_868_15331"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.176471 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_868_15331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_868_15331",
    x: -20.2575,
    y: -24.6065,
    width: 80.2202,
    height: 79.3322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_868_15331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_868_15331",
    x: -14.0881,
    y: -18.5829,
    width: 61.4396,
    height: 60.737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_868_15331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_868_15331",
    x: 13.1472,
    y: 28.6887,
    width: 27.6895,
    height: 23.0324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83129,
    result: "effect1_foregroundBlur_868_15331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_15331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3Red);
export default __webpack_public_path__ + "static/media/number3-red.81d66b42eade3ee4fc288a30f0a7216d.svg";
export { ForwardRef as ReactComponent };